(function(){
 'use strict';
 const dialog=document.querySelector('#ps-stock-dialog'),form=document.querySelector('#ps-stock-form');
 function needsCheck(v,quantity=1){return !!v&&(v.texas==null||v.texas<=0||(Number.isInteger(Number(quantity))&&Number(quantity)>v.texas));}
 function details(p,v,state={}){
  const quantity=Number.isInteger(Number(state.quantity))&&Number(state.quantity)>0?Number(state.quantity):1;
  const params=new URLSearchParams({id:p.id,color:v.color,size:v.size||'',quantity:String(quantity)});
  if(state.mode==='blank')params.set('finish','blank');
  const url=new URL('/products/'+p.handle,location.origin);url.hash='product?'+params;
  const name=window.PS_PRODUCT_INFO?.displayName(p)||p.name,size=window.PS_PRODUCT_INFO?.fitLabel(p,v.size)||v.size||'One size';
  return {name,color:v.color,size,quantity,url:url.href,finish:state.mode==='blank'?'Blank — No Embroidery':'Custom embroidery',
   message:['Hello PrintStitch Texas,','Could you please check current availability for this product and color?','',
    'Product: '+name,'Color: '+v.color,'Size: '+size,'Quantity: '+quantity,'Finish: '+(state.mode==='blank'?'Blank — No Embroidery':'Custom embroidery'),
    'Product link: '+url.href,'','Please reply by email with availability. Thank you.'].join('\n')};
 }
 function open(p,v,state){
  if(!dialog||!form||!v)return;
  const d=details(p,v,state);form.reset();
  form.querySelector('[name="contact[body]"]').value=d.message;
  form.querySelector('[name="contact[Product]"]').value=d.name;
  form.querySelector('[name="contact[Color]"]').value=d.color;
  form.querySelector('[name="contact[Size]"]').value=d.size;
  form.querySelector('[name="contact[Quantity]"]').value=d.quantity;
  form.querySelector('[name="contact[Product link]"]').value=d.url;
  form.querySelector('[name="contact[name]"]').value='Stock check — '+d.name;
  dialog.querySelector('[data-stock-summary]').textContent=d.name+' · '+d.color+' · '+d.size+' · Qty '+d.quantity;
  dialog.querySelector('[data-stock-entry]').hidden=false;
  dialog.querySelector('[data-stock-confirmation]').hidden=true;
  dialog.showModal();form.querySelector('[type="email"]').focus();
 }
 function mount(anchor,p,v,state={}){
  if(!anchor)return;let box=anchor.nextElementSibling;
  if(!box?.classList.contains('stock-request-option')){
   box=document.createElement('div');box.className='stock-request-option';
   box.innerHTML='<p>Need this color? We can check availability for you.</p><button type="button" class="text-link">Ask us to check stock →</button>';anchor.after(box);
  }
  box.hidden=!needsCheck(v,state.quantity);box.querySelector('button').onclick=()=>open(p,v,state);
 }
 window.PS_STOCK_REQUEST={needsCheck,details,mount,open};
 if(!dialog||!form)return;
 dialog.querySelector('[data-stock-close]').onclick=()=>dialog.close();
 // Shopify can intercept the click/submit at document capture before our form
 // submit handler runs. Dismiss the top-layer dialog first, without cancelling
 // the event, so its native security challenge stays visible and operable.
 const revealVerification=()=>{if(dialog.open&&form.checkValidity())dialog.close();};
 window.addEventListener('click',e=>{
  const submitter=e.target?.closest?.('button[type="submit"],input[type="submit"]');
  if(submitter?.form===form&&!submitter.disabled)revealVerification();
 },true);
 window.addEventListener('submit',e=>{if(e.target===form)revealVerification();},true);
 form.addEventListener('submit',e=>{
  if(!form.checkValidity()){e.preventDefault();form.reportValidity();return;}
  dialog.close();
  // Shopify handles submission and verification. A confirmation opens separately
  // so an unsaved Studio design stays intact in the original tab. Close the
  // native dialog first so Shopify's hCaptcha can appear above the storefront.
 });
 const sent=form.querySelector('[data-stock-server-result]')?.dataset.stockServerResult==='sent';
 if(sent||form.querySelector('.stock-request-errors')){
  const result=dialog.querySelector('[data-stock-confirmation]');
  dialog.querySelector('[data-stock-entry]').hidden=true;result.hidden=false;
  if(!sent){result.setAttribute('role','alert');result.textContent='Your request was not sent. '+form.querySelector('.stock-request-errors').textContent.trim()+' Return to your product tab and try again.';}
  dialog.showModal();
 }
})();
